"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDateOfDeathProperty = exports.dateOfDeathPropertyDefinition = void 0;
exports.dateOfDeathPropertyDefinition = {
    view: { label: 'Date of death' },
    constraints: [],
    type: 'date',
    multiple: false,
    name: 'date-of-death',
};
const isDateOfDeathProperty = (prop) => {
    return prop.name === exports.dateOfDeathPropertyDefinition.name;
};
exports.isDateOfDeathProperty = isDateOfDeathProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGF0ZS1vZi1kZWF0aC5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2RhdGUtb2YtZGVhdGgucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSw2QkFBNkIsR0FBRztJQUMzQyxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsZUFBZSxFQUFFO0lBQ2hDLFdBQVcsRUFBRSxFQUFFO0lBQ2YsSUFBSSxFQUFFLE1BQU07SUFDWixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxlQUFlO0NBQ1UsQ0FBQTtBQUkxQixNQUFNLHFCQUFxQixHQUFHLENBQUMsSUFBa0IsRUFBK0IsRUFBRTtJQUN2RixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUsscUNBQTZCLENBQUMsSUFBSSxDQUFBO0FBQ3pELENBQUMsQ0FBQTtBQUZZLFFBQUEscUJBQXFCLHlCQUVqQyJ9